<script>
export default {
  components: {},
  created: () => {
    document.body.classList.add('authentication-bg')
    document.body.classList.add('authentication-bg-pattern')
  },
}
</script>

<template>
  <div>
    <div>
      <div class="fluid-container">
        <slot />
      </div>
    </div>
  </div>
</template>
